import { render } from "./CallbackModal.vue?vue&type=template&id=0fbae39c&scoped=true"
import script from "./CallbackModal.vue?vue&type=script&lang=js"
export * from "./CallbackModal.vue?vue&type=script&lang=js"

import "./CallbackModal.vue?vue&type=style&index=0&id=0fbae39c&scoped=true&lang=css"

import exportComponent from "/Users/k.belov/Programming/sites/gl_site/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbae39c"]])

export default __exports__